import { call, put, takeLatest } from "redux-saga/effects";
import ProcedimientoActions, {
  Types as ProcedimientoTypes,
} from "../../stores/procedimiento/Actions";
import AuthService from "../../services/auth/AuthService";
import PrestadorService from "../../services/prestador/PrestadorService";
import ProcedimientoService from "../../services/procedimiento/ProcedimientoService";
import ResponseCode from "../../services/ResponseCode";
import { isEmptyValue } from "../../utils/StringUtil";
import {
  COBERTURAS_MONTOS_MODIFICABLES,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
} from "../../containers/autorizacion/utils/AutorizacionConstant";

function* validarProcedimiento(request) {
  yield put(ProcedimientoActions.validarProcedimientoLoading());

  const {
    numeroSesion,
    codigoProcedimiento,
    tipoServicio,
    nombreCobertura,
    frecuencia,
    isFromModal,
    monto,
    servicio,
  } = request.payload;

  let nombreProcedimiento = nombreCobertura;

  if (!isFromModal) {
    let requestProcedimiento = {
      cobertura: codigoProcedimiento,
      servicio: servicio,
    };

    const procedimientosResponse = yield call(
      PrestadorService.consultarProcedimientosPss,
      requestProcedimiento
    );

    if (procedimientosResponse?.data?.procedimientos?.length > 0) {
      nombreProcedimiento =
        procedimientosResponse?.data?.procedimientos[0]?.nombreCobertura;
    }
  }

  let requestValidar = {
    codigoProcedimiento,
    tipoServicio,
    frecuencia,
  };

  if (
    (COBERTURAS_MONTOS_MODIFICABLES.includes(codigoProcedimiento) ||
      Number(servicio) === Number(CODIGO_TIPO_SERVICIO_AUTORIZACION.ALTO_COSTO)) &&
    !isEmptyValue(monto) &&
    Number(monto) > 0
  ) {
    requestValidar.monto = Number(monto);
  }

  const validarProcedimientoResponse = yield call(
    ProcedimientoService.validarProcedimiento,
    AuthService.handleRequestSession(requestValidar, numeroSesion)
  );

  if (
    !validarProcedimientoResponse?.respuesta ||
    validarProcedimientoResponse?.respuesta?.codigo ===
      ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      ProcedimientoActions.validarProcedimientoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    validarProcedimientoResponse?.respuesta?.mensaje !== ResponseCode.OK.message
  ) {
    yield put(
      ProcedimientoActions.validarProcedimientoFailure(
        validarProcedimientoResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    ProcedimientoActions.validarProcedimientoSuccess({
      ...validarProcedimientoResponse?.data,
      tipoServicio,
      nombreCobertura: nombreProcedimiento,
      isFromModal,
    })
  );
}

function* eliminarProcedimiento(request) {
  yield put(ProcedimientoActions.eliminarProcedimientoLoading());

  const { numeroSesion, codigoProcedimiento } = request.payload;

  const requestEliminar = {
    codigoProcedimiento,
  };
  const eliminarProcedimientoResponse = yield call(
    ProcedimientoService.eliminarProcedimiento,
    AuthService.handleRequestSession(requestEliminar, numeroSesion)
  );

  if (
    !eliminarProcedimientoResponse?.respuesta ||
    eliminarProcedimientoResponse?.respuesta?.codigo ===
      ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      ProcedimientoActions.eliminarProcedimientoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    eliminarProcedimientoResponse?.respuesta?.codigo !== ResponseCode.OK.code
  ) {
    yield put(
      ProcedimientoActions.eliminarProcedimientoFailure(
        eliminarProcedimientoResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    ProcedimientoActions.eliminarProcedimientoSuccess({
      ...eliminarProcedimientoResponse?.data,
      key: request?.payload?.key,
    })
  );
}

const exportedArray = [
  takeLatest(ProcedimientoTypes.VALIDAR_PROCEDIMIENTO, validarProcedimiento),
  takeLatest(ProcedimientoTypes.ELIMINAR_PROCEDIMIENTO, eliminarProcedimiento),
];

export default exportedArray;
